import React from 'react'
import { compose, setDisplayName } from 'recompose'
import { connect } from "react-redux";
import { CLOUD_URL } from '../../../../constants'

import './Header.css'

import logo from '../../../../assets/icons/logo.svg'

const mapStateToProps = (state) => ({
  bookInfo: state.reader.bookInfo,
  isSampleMode: state.reader.isSampleMode,
  language: state.userData.language
})

const mapDispatchToProps = (dispatch) => ({
})

const Logo = ({isSampleMode}) => (
  <figure className="Header__logo">
    {isSampleMode ?
      <img src={logo} alt="PocketBook"/> :
      <img src={logo} alt="PocketBook" onClick={() => window.location = CLOUD_URL}/>
    }
  </figure>
)

export const enhance = compose(
  setDisplayName('Header'),
  connect(mapStateToProps, mapDispatchToProps)
)

export const View = ({bookInfo, isSampleMode}) => (
  <header className="Header">
    <Logo isSampleMode={isSampleMode}/>
    {!isSampleMode ? <div className="bookTitle">{bookInfo.title}</div> : ''}
  </header>
)

export const Header = enhance(View)



// WEBPACK FOOTER //
// ./src/components/Reader/components/Header/Header.js